import * as ImagePicker from 'expo-image-picker'

export interface ScanResult {
  uri: string
}

export type ScanOutcome =
  | { status: 'ok'; uri: string }
  | { status: 'cancel' }
  | { status: 'error'; error: unknown }

/**
 * Open the webcam to capture a document photo.
 * Uses the rear camera when available (device camera for documents).
 *
 * Mirrors the native module's outcome contract: a cancel and a failure are
 * distinct, so the UI can stay silent on the first and explain itself on the
 * second instead of leaving the button looking dead.
 */
export async function scanDocumentOutcome(): Promise<ScanOutcome> {
  try {
    const result = await ImagePicker.launchCameraAsync({
      mediaTypes: ['images'],
      quality: 0.85,
      allowsEditing: false,
    })

    if (result.canceled) return { status: 'cancel' }
    const uri = result.assets[0]?.uri
    if (!uri) return { status: 'cancel' }

    return { status: 'ok', uri }
  } catch (error) {
    return { status: 'error', error }
  }
}
